/**
 * 租户间稿库
 * 2019-05-20
 * zhang.yingyu
 */
"use strict";
angular.module("postTenantLeftModule", [])
    .directive("postTenantLeft", ["$state", "resourceCenterService", "$q", "$timeout", "$stateParams", "trsHttpService", function($state, resourceCenterService, $q, $timeout, $stateParams, trsHttpService) {
        return {
            replace: false,
            restrict: "E",
            scope: {
                firstNav: "="
            },
            templateUrl: "./resourceCenter/tenantManuscript/postTenant/left/left.html",
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    initSelect();
                }
                /**
                 * [initSelect description] 初始化选择
                 * @param {object} [items] [description] 
                 * @return {[type]} [description]
                 */
                function initSelect() {
                    if ($stateParams.onlyExpand) {
                        goTo('', '');
                        $scope.$parent.$parent.selectedStatus = 'weixuanze';
                        return;
                    }
                    var flag = false;
                    for (var i in $scope.firstNav) {
                        var nav = $scope.firstNav[i];
                        if (nav.hid === $stateParams.hid) {
                            $scope.status.selectedNav = nav;
                            flag = true;
                            break;
                        }
                    }
                    if (!flag) {
                        goTo('', '');
                        $scope.$parent.$parent.selectedStatus = 'weixuanze';
                    }
                }
                /**
                 * [firstNavSelected description] 判断一级菜单是否选中
                 * @param {object} [items] [description] 一级菜单
                 * @return {[type]} [description]
                 */
                $scope.firstNavSelected = function(items) {
                    if ($scope.status.selectedNav != undefined) {
                        return items.hid === $scope.status.selectedNav.hid ? 'active' : '';
                    } else {
                        return "";
                    }
                };
                /**
                 * [clickSecond description] 点击二级分类
                 * @param {object} [item] [description] 二级分类信息
                 * @return {[type]} [description]
                 */
                $scope.selectMedia = function($event, item) {
                    $event.stopPropagation();
                    goTo(item, item.hid);
                };
                /**
                 * [goTo description] 路由切换
                 * @return {[type]} [description]
                 */
                function goTo(item, hid) {
                    $scope.status.selectedNav = item;
                    resourceCenterService.go("front.resourcectrl.tenantmanuscript.post", {
                        hid: hid
                    });
                }
            }
        };
    }]);